import { render, staticRenderFns } from "./Effect.vue?vue&type=template&id=0ab3fefb&"
import script from "./Effect.vue?vue&type=script&lang=js&"
export * from "./Effect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports